
import $ from 'jquery';
import _forEach from 'lodash/forEach';
import _isNaN from 'lodash/isNaN';
import { SELECTORS } from '../constants/selectors';
import EventBus from '../lib/EventBus';
import TestController from './TestController';
import { EVENT } from '../constants/eventNames';

/**
 * @property UI_FEEDBACK_DIALOG_TEMPLATE
 * @type {string}
 * @final
 */
const UI_TESTLOG_DWN_DIALOG_TEMPLATE = `
    <div class="option-dialog dialog">
        <p class="dialog-title">Test log download</p>
        <div class="dialog-body nice-scrollbar">
        </div>
    </div>`;

/**
 * @property UI_FEEDBACK_CLOSE_DIALOG_BUTTON
 * @type {string}
 * @final
 */
const UI_TESTLOG_DWN_TABLE_TEMPLATE = `
    <table style="width: 100%;">
        <tr>
            <th>Test Name</th>
            <th>Test ID</th>
            <th>User ID</th>
            <th>Test Date</th>
            <th>Download</th>
        </tr>
    </table>`;

/**
 * @property UI_FEEDBACK_DOWNLOAD_BUTTON
 * @type {string}
 * @final
 */
const UI_TESTLOG_DWN_CLEAR_BUTTON = `
    <button class="dialog-body-download-button" style="margin-left: 5px;">Clear all test logs</button>`;


export default class TestlogDownloadUiController {
    
    constructor($element){

        /**
         * Root DOM element
         *
         * @property $element
         * @type {jquery|HTML Element}
         * @default $element
         */
        this.$element = $element;

        /**
         * Dialog DOM element
         *
         * @property $dialog
         * @type {jquery|HTML Element}
         * @default null
         */
        this.$dialog = null;

        /**
         * Dialog's body DOM element
         *
         * @property $dialogBody
         * @type {jquery|HTML Element}
         * @default null
         */
        this.$dialogBody = null;

        /**
         * Local event bus
         * 
         * @property _eventBus
         * @type {EventBus}
         * @default EventBus
         */
        this._eventBus = EventBus;

        this.init().setupHandlers().enable();
    }

    /**
     * Initializes the testing dialog
     * 
     * @for TesetFeedbackUiController
     * @method init
     * @private
     * @chainable
     */
    init(){
        this._buildDialog();

        return this;
    }

    setupHandlers() {
        this._redrawTableHandler = this._loadTableWithTestData.bind(this);

        return this;
    }

    enable() {
        this._eventBus.on(EVENT.TESTLOG_DOWNLOAD_MENU_UPDATED, this._redrawTableHandler);

        return this;
    }

    disable() {
        this._eventBus.off(EVENT.TESTLOG_DOWNLOAD_MENU_UPDATED, this._redrawTableHandler);

        return this;
    }

    /**
     * Builds the testing dialog
     * 
     * @for TesetFeedbackUiController
     * @method _buildDialog
     * @private
     */
    _buildDialog() {
        this.$dialog = $(UI_TESTLOG_DWN_DIALOG_TEMPLATE);
        this.$dialogBody = this.$dialog.find(SELECTORS.DOM_SELECTORS.DIALOG_BODY);

        this._loadTableWithTestData();

        this.$element.append(this.$dialog);
    }

    _loadTableWithTestData() {
        this.$dialogBody.empty();
        let table = $(UI_TESTLOG_DWN_TABLE_TEMPLATE);
        let tbody = table.find('tbody');
        const testLogs = TestController.getStoredTestData();
    
        if (testLogs.length === 0) {
            this.$dialogBody.text('No test logs available');
            return;
        }
        
        for (let i = 0; i < testLogs.length; i++) {
            const generalInfo = testLogs[i].GENERAL_INFORMATION[0];
            const userId = generalInfo.UserId;
            const date = generalInfo.Date;
            const testName = generalInfo.TestName;
            const testId = generalInfo.TestId;
    
            // Create a download button for each row
            const $downloadButton = $('<button>').text('Download');
            $downloadButton.attr('index-in-localstorage', i);
    
            $downloadButton.on('click', () => {
                const index = parseInt($downloadButton.attr('index-in-localstorage'));
                const allTestLogs = TestController.getStoredTestData();
    
                // Check if the index is valid
                if (isNaN(index) || index < 0 || index >= allTestLogs.length) {
                    console.error('Invalid index for test log');
                    return;
                }
    
                const testLog = allTestLogs[index];
                TestController.downloadTestLog(testLog);
            });
    
            let $row = $('<tr>');
            $row.append($('<td>').text(testName));
            $row.append($('<td>').text(testId));
            $row.append($('<td>').text(userId));
            $row.append($('<td>').text(date));
            $row.append($('<td>').append($downloadButton));
            
            tbody.append($row);
        }

        const $clearButton = $(UI_TESTLOG_DWN_CLEAR_BUTTON);
        $clearButton.on('click', () => {
            TestController.clearLocalStorage();
            this._loadTableWithTestData();
        });
    
        this.$dialogBody.append(table);

        this.$dialogBody.append($clearButton);
    }

    /**
     * Returns whether the testing dialog is open
     *
     * @for TesetFeedbackUiController
     * @method isDialogOpen
     * @return {boolean}
     */
    isDialogOpen() {
        return this.$dialog.hasClass(SELECTORS.CLASSNAMES.OPEN);
    }

    /**
     * Toggles the testing dialog
     * 
     * @for TesetFeedbackUiController
     * @method toggleDialog
     */
    toggleDialog() {
        this._loadTableWithTestData();
        this.$dialog.toggleClass(SELECTORS.CLASSNAMES.OPEN);
    }

}